import { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import {
  clearTrackingConsentSessionDismissal,
  dismissTrackingConsentForSession,
  getTrackingConsent,
  hasDismissedTrackingConsentForSession,
  hasStoredTrackingConsent,
  setTrackingConsent,
} from "../lib/trackingConsent";

function AnalyticsConsentBanner() {
  const [visible, setVisible] = useState(
    !hasStoredTrackingConsent() && !hasDismissedTrackingConsentForSession()
  );
  const [consentGranted, setConsentGranted] = useState(getTrackingConsent());

  useEffect(() => {
    const handleOpen = () => {
      setVisible(true);
    };

    const handleConsentChanged = (event) => {
      setConsentGranted(Boolean(event?.detail?.granted));
      setVisible(false);
    };

    window.addEventListener("proshare:open-tracking-consent", handleOpen);
    window.addEventListener("proshare:tracking-consent-changed", handleConsentChanged);

    return () => {
      window.removeEventListener("proshare:open-tracking-consent", handleOpen);
      window.removeEventListener("proshare:tracking-consent-changed", handleConsentChanged);
    };
  }, []);

  const handleChoice = (granted) => {
    clearTrackingConsentSessionDismissal();
    setConsentGranted(granted);
    setTrackingConsent(granted);
    setVisible(false);
  };

  const handleClose = () => {
    if (!hasStoredTrackingConsent()) {
      dismissTrackingConsentForSession();
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[60] mx-auto max-w-2xl rounded-2xl border border-slate-200 bg-white/95 p-4 shadow-[0_18px_52px_rgba(15,23,42,0.14)] backdrop-blur">
      <button
        type="button"
        onClick={handleClose}
        className="absolute right-3 top-3 inline-flex h-8 w-8 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-500 transition hover:border-slate-300 hover:text-slate-700"
        aria-label="Close tracking preferences banner"
      >
        <FiX className="text-base" />
      </button>
      <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
        <div className="space-y-1.5">
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-sky-700">
            Privacy Controls
          </p>
          <p className="text-sm font-semibold text-slate-900">Tracking preferences</p>
          <p className="max-w-xl text-xs leading-5 text-slate-600">
            Practidex can use Google Analytics and, if later enabled for launch, consent-gated
            session insights to understand navigation, product views, and conversion flows. These
            non-essential trackers stay off unless you allow them.
          </p>
          <p className="text-[11px] font-medium text-slate-500">
            Current setting: {hasStoredTrackingConsent() ? (consentGranted ? "analytics allowed" : "analytics rejected") : "awaiting your choice"}
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => handleChoice(false)}
            className="inline-flex min-w-[110px] items-center justify-center rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
          >
            Reject
          </button>
          <button
            type="button"
            onClick={() => handleChoice(true)}
            className="inline-flex min-w-[140px] items-center justify-center rounded-xl bg-sky-600 px-3 py-2 text-sm font-semibold text-white transition hover:bg-sky-700"
          >
            Allow analytics
          </button>
        </div>
      </div>
    </div>
  );
}

export default AnalyticsConsentBanner;
